import React, { useCallback,useEffect, useMemo, useState } from 'react'
import { Container, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { INITIAL_ROW_SELECTION_MODEL } from '../../../../components/DataGridV2/constants';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../../../_constants';
import { formatDate, getLocalStorageItem, setLocalStorageItem } from '../../../../_helpers';
import { questionnaireTemplateActions } from '../../../../_actions/questionnaireTemplate.actions';
import { makeStyles } from '@mui/styles';
import DataGridV2 from '../../../../components/DataGridV2';
import { getQuestionnaireTemplateColumns } from './utils';

const QuestionnaireTemplateGrid = ({ setIsToggleDrawer,onSelect }) => {
  const classes = useStyles();
  const app = useSelector((state) => state.app);
  const theme = useTheme()
  const apiRef = useGridApiRef();
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const keyPrefix =  app === apps.constructionQuality ? "CONSTRUCTION_QUALITY" : "GENERAL";
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_PAGINATION[keyPrefix], undefined
  ))
  const { questionnaireStore: { questionnaireTemplate: { templateList } } } = useSelector(state => state);

   useEffect(() => {
      return () => {
        dispatch(questionnaireTemplateActions.questionnaireClearTemplateStore())
      }
    }, [])
  
  useEffect(() => {
    dispatch(questionnaireTemplateActions.questionnaireFetchTemplateLists(t))
  }, [dispatch, t]);

  const columns = getQuestionnaireTemplateColumns({ t, theme, keyPrefix, i18n, apiRef,onSelect})

  const onPaginationModelChange = useCallback((newPaginationModel) => {
    setPaginationModel(newPaginationModel)
    setLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_PAGINATION[keyPrefix],
      newPaginationModel
    );
  }, [keyPrefix])


const getToolbarProps = useMemo(() => ({
  toolbarStartActions: !onSelect
    ? [
        {
          title: t("general.add"),
          icon: Add,
          onClick: () => setIsToggleDrawer(true),
        },
      ]
    : [],
}), [onSelect, t, setIsToggleDrawer]);

  const getQuestionTemplateForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? templateList?.data : idsToExport?.map((id) => templateList?.data.find(item => item?.id === id));

    const results = userSelectedRows?.map((item) => {
      let result = {}
      Object.keys(item).forEach((key) => {
        let value = item[key];
        const isDateField = columns.some(x => x.field === key && x.type === 'date');
        const isDateTimeField = columns.some(x => x.field === key && x.type === 'dateTime');
        if (isDateField) {
          value = item[key] ? formatDate(new Date(item[key])) : "";
        } else if (isDateTimeField) {
          value = item[key] ? formatDate(new Date(item[key]), true, "-", false) : "";
        } else if (key === "active") {
          value = item[key] ? t("general.yes") : t("general.no");
        }

        result[key] = value;
      });
      return result
    })
    return results
  }

  return (
    <Container maxWidth={false} className={classes.mainContainer}>
      <DataGridV2
        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_SEARCH_TEXT[keyPrefix]}
        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_FILTER[keyPrefix]}
        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_SORT[keyPrefix]}
        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_ORDER[keyPrefix]}
        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_WIDTH[keyPrefix]}
        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_VISIBILITY[keyPrefix]}
        apiRef={apiRef}
        loading={templateList?.loading}
        checkboxSelection={!onSelect} 
        rows={onSelect
          ? templateList?.data?.filter(item => item.active === true)
          : templateList?.data
        }
        columns={columns}
        toolbarProps={{
          ...getToolbarProps,
          selectedRows: rowSelectionModel,
          getData: getQuestionTemplateForPrintAndDownload,
          title: t("general.template"),
        }}
        pagination
        rowSelectionModel={rowSelectionModel}
        {...(!!paginationModel && { paginationModel })}
        onPaginationModelChange={onPaginationModelChange}
        filterMode="client"
        onRowClick={(rowData)=>onSelect && onSelect(rowData.row)}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
      />
    </Container>
  )
}

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    width: "100%",
    overflow: "auto",
    padding: 0,

  },
}));
export default QuestionnaireTemplateGrid
